module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-900.74c0271.woff2";